<div class="col px-0">
    <div class="d-flex align-items-center justify-content-center">
        <div class="col text-primary font-semibold f-14 mb-0 p-2">
            Payment List
        </div>
        <div class="col d-flex align-items-center justify-content-end gap-1">
            <div class="d-flex align-items-center position-relative">
                <span class="f-10 font-semibold  position-absolute filter_count" >
                    <span class="d-flex justify-content-center">{{filterCountValue}}</span>
                </span>
                <app-button class="" (click)="openAdvanceFilterPopUp()" showFilterIcon="true"
                    [buttonClass]="'white_button common-filter-size gap-0'" [buttonType]="'button'" showIconCount="true">
                </app-button>
            </div>
            <div class="d-flex align-items-center">
                <app-button class="" showRefreshIcon="true" [buttonClass]="'white_button common-refresh-size gap-0'"
                            [buttonType]="'button'" (buttonOutputEvent)="resetFilter()">
                </app-button>
            </div>
            <div>
                <app-export-dropdown
                    [requestModel]="exportBindParameterBasedOnTab(exportDropdownBindDynamicParameter?.RequestModel)"
                    [gridApi]="exportBindParameterBasedOnTab(exportDropdownBindDynamicParameter?.GridApi)"
                    [gridName]="exportBindParameterBasedOnTab(exportDropdownBindDynamicParameter?.GridName)"
                    (callApiForExport)="callApiForExport()"></app-export-dropdown>
            </div>
        </div>
    </div>
    <div class="position-relative" id="sale_bill_Payment" [ngClass]="voucherType === 'Expense' || voucherType === 'income' ? 'h_cal_625' : 'h-250px'">
        <app-ag-grid 
            class="w-100"
            [id]="voucherType === 'Expense' || voucherType === 'income' ? 'h_cal_630' : 'payment_list'"
            [dataModel]="agGridDataModelPaymentList"
            [columnSettings]="true"
            (gridReady)="onGridReady($event)"
            (onDeleteIconClick)="onDeleteIconClick($event)"
            (onTextCellClick) = "textCellClick($event)"
            (onEditIconClick)="onEditIconClick($event)"
            (onPagination)="onPagination($event)"
            (onSortIconClick)="onSortIconClick($event)"
            >
        </app-ag-grid>
        <hr class="mb-0 pt-1 mt-1 border-gray-color" />
    </div>
</div>